// Helper: make sure we only call .json() on real JSON responses
export const ensureJsonResponse = async <T>(
  resp: Response,
  context: string,
): Promise<T> => {
  const contentType = resp.headers.get('content-type') || '';

  // If it really looks like JSON, try to parse it
  if (
    contentType.includes('application/json') ||
    contentType.includes('json')
  ) {
    try {
      return (await resp.json()) as T;
    } catch (e) {
      console.error(`❌ Failed to parse JSON for ${context}`, e);
      throw new Error(`Failed to parse JSON response for ${context}`);
    }
  }

  // Otherwise, grab a small snippet so we can see what we actually got
  const text = await resp.text();
  console.error(`❌ Expected JSON from ${context}, but got non-JSON response`, {
    status: resp.status,
    contentType,
    snippet: text.slice(0, 200),
  });

  throw new Error(
    `Unexpected non-JSON response from ${context} (status ${resp.status}).` +
      ` This often means CloudFront returned index.html instead of the API response. ` +
      `Check console for details.`,
  );
};
